<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Komunikaty grupowe ({{departmentName}})</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>

		<v-dialog v-model="dialog" max-width="700px">
			<v-btn v-if="!roles.isDepartmentEmployee()" slot="activator" color="primary" dark class="mb-4">
				Dodaj nową grupę
			</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja grupy</span>
					<span class="headline" v-else> Dodaj nową grupę</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field v-model="editedItem.name"
									label="Nazwa"
									aria-label="name"
									browser-autocomplete="off"
									for="notification-group-list-view-name"
									id="notification-group-list-view-name"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-data-table
			hide-actions
			:headers="tableHeaders"
			:items="notificationGroups">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon v-if="!roles.isDepartmentEmployee() && props.item.id !== undefined"
								@click="editItem(props.item)">
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj grupę</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon v-if="!roles.isDepartmentEmployee() && props.item.id !== undefined"
								@click="deleteItem(props.item)">
								<v-icon v-on="on" color="lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń grupę</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon v-if="props.item.id !== undefined"
								@click="showUserList(props.item)">
								<v-icon v-on="on">
									people
								</v-icon>
							</v-btn>
						</template>
						<span>Użytkownicy</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon
								@click="createNotification(props.item)">
								<v-icon v-on="on">
									mail
								</v-icon>
							</v-btn>
						</template>
						<span>Wyślij komunikat</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>

		<v-dialog v-model="messageDialog"
			:persistent="notification.contestId !== null || notification.title !== '' || notification.message !== ''"
			max-width="1000px">
			<v-card>
				<v-card-title class="headline mb-3">Nowy komunikat ({{notificationRecipientGroupName}})</v-card-title>

				<v-layout row v-if="showContestField">
					<v-flex xs1/>
					<v-flex xs10>
						<v-autocomplete
							v-model="notification.contestId"
							:items="contests"
							label="Konkurs"
							item-text="name"
							item-value="id"
							aria-label="label for text"
							solo>
						</v-autocomplete>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-layout row v-if="showAgencyContestField">
					<v-flex xs1/>
					<v-flex xs10>
						<v-autocomplete
							v-model="notification.contestId"
							:items="agencyContests"
							label="Nabór"
							item-text="name"
							item-value="id"
							aria-label="label for text"
							solo>
						</v-autocomplete>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-layout row>
					<v-flex xs1/>
					<v-flex xs10>
						<v-text-field
							browser-autocomplete="off"
							v-model="notification.title"
							label="Tytuł"
							aria-label="title"
							for="notification-group-list-view-title"
							id="notification-group-list-view-title"
							single-line
							solo></v-text-field>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-spacer/>

				<v-layout row>
					<v-flex xs1/>
					<v-flex xs10>
						<v-textarea
							browser-autocomplete="off"
							v-model="notification.message"
							solo aria-label="notification message"></v-textarea>
					</v-flex>
					<v-flex xs1/>
				</v-layout>

				<v-layout row>
					<v-flex xs1/>
					<v-flex xs3>
						Lista załączników
					</v-flex>
					<v-spacer/>
					<v-flex xs3>
						<v-btn @click="$refs.fileInput.click()" color="primary">
							Dodaj załącznik
						</v-btn>
					</v-flex>
					<v-flex xs1/>
				</v-layout>


				<v-list>
					<template v-for="(item, index) in notification.files">
						<v-list-tile :key="item.id" avatar>
							<v-list-tile-content>
								<v-list-tile-title v-html="item.name"></v-list-tile-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-btn @click="deleteFile(item, index)" icon ripple>
									<v-icon color="lightred">delete</v-icon>
								</v-btn>
							</v-list-tile-action>
						</v-list-tile>
					</template>
				</v-list>

				<input @change="updateFiles" ref="fileInput" id="fileInput" multiple type="file" v-show="false"
					:accept="acceptedFiles"
					aria-label="label for input">

				<v-spacer/>

				<v-card-actions>
					<v-btn color="blue"
						@click="handleClosingMessageDialog">
						Anuluj
					</v-btn>
					<v-btn color="primary"
						:disabled="notificationSendDisabled"
						flat
						@click="sendNotification">
						Wyślij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dataLossPromptDialog" persistent max-width="600px">
			<v-card>
				<div class="mt-1">
					<v-alert
						:value="true"
						color="error"
						icon="warning"
					>
						Czy na pewno chcesz anulować edycję?
					</v-alert>
				</div>
				<v-card-text>Treść komunikatu zostanie usunięta.</v-card-text>
				<v-spacer/>
				<v-card-actions>
					<v-btn color="blue darken-1"
						flat
						@click="dataLossPromptDialog = false">
						Nie
					</v-btn>
					<v-btn color="blue darken-1"
						flat
						@click="handleClosingDataLossPromptDialog">
						Tak
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-card>
</template>

<script>
	import {Notification} from "@/api/generated/Notification";
	import {Department} from "@/api/generated/Department";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import {Api} from "@/api";
	import {Files} from "@/utils/Files";

	export default {
		name: "NotificationGroupListView",

		data() {
			return {
				dialog: false,
				editedItem: {},
				editedIndex: -1,
				notificationGroups: [],
				notificationRecipientGroup: Object,
        notificationRecipientGroupName: "",
				messageDialog: false,
				dataLossPromptDialog: false,
				defaultGroups: [
					{id: undefined, name: "Oferenci"},
					{id: undefined, name: "Oferenci konkursu"},
					{id: undefined, name: "Wolontariusze"},
					{id: undefined, name: "Wolontariusze konkursu"},
					{id: undefined, name: "Pracownicy placówek"},
					{id: undefined, name: "Pracownicy departamentu"},
					{id: undefined, name: "Opiniujący konkursu"},
					{id: undefined, name: "Opiniujący naboru"}
				],
				tableHeaders: [
					{
						text: "Nazwa",
						sortable: false,
					},
					{
						text: "Akcje",
						sortable: false,
					},
				],
				notification: {
					contestId: null,
					title: '',
					message: "",
					files: [],
				},
				contests: [],
        agencyContests: [],
				departmentName: "",
			};
		},

		methods: {
			deleteFile(file, idx) {
				this.notification.files.splice(idx, 1);
			},

			async updateFiles() {
				if (this.hasIncorrectFilesExtension(this.$refs.fileInput.files)) {
					Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}

				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.fileInput.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
				for (let i = 0; i < this.$refs.fileInput.files.length; ++i) {
					this.notification.files.push(this.$refs.fileInput.files[i]);
				}
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			closeMessageDialog() {
				this.messageDialog = false;
        this.notificationRecipientGroupName = "";
			},

			handleClosingMessageDialog() {
				if (this.notification.contestId !== null || this.notification.title !== "" || this.notification.message !== "") {
					this.dataLossPromptDialog = true;
				} else this.closeMessageDialog();
			},

			handleClosingDataLossPromptDialog() {
				this.dataLossPromptDialog = false;
				this.closeMessageDialog();
			},

			save() {
				if (this.editedIndex === -1) {
					this.createNotificationGroup();
				} else {
					this.updateNotificationGroup();
				}
			},

			editItem(item) {
				this.editedIndex = this.notificationGroups.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć grupę komunikatów?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie grupy",
					width: 500
				})
					.then(res => {
						if (res) {
							const index = this.notificationGroups.indexOf(item);
              this.deleteNotificationGroup(item.id, index);
						}
					});
			},

			showUserList(item) {
				this.$router.push("/app/notification-groups/" + this.$route.params.departmentId + "/users/" + item.id);
			},

			createNotification(item) {
				this.notificationRecipientGroup = Object.assign({}, item);
        this.notificationRecipientGroupName = item.name;
				this.messageDialog = true;
			},

			sendNotification() {
				if (this.notificationRecipientGroup.id === undefined) {
					switch (this.notificationRecipientGroup.name) {
						case 'Oferenci':
              this.sendNotificationToBidders();
							break;
						case 'Wolontariusze':
              this.sendNotificationToVolunteers();
							break;
						case 'Pracownicy placówek':
              this.sendNotificationToAgencyEmployees();
							break;
						case 'Pracownicy departamentu':
              this.sendNotificationToDepartmentEmployees();
							break;
						case 'Oferenci konkursu':
              this.sendNotificationToContestBidders();
							break;
            case 'Wolontariusze konkursu':
              this.sendNotificationToContestVolunteers();
              break;
            case 'Opiniujący konkursu':
              this.sendNotificationToContestEvaluators();
              break;
            case 'Opiniujący naboru':
              this.sendNotificationToAgencyContestEvaluators();
              break;
					}
				} else {
          this.sendNotificationToGroup();
				}
				this.closeMessageDialog();
			},

      getDepartmentName() {
        Department.getName(this, this.$route.params.departmentId, successResponse => {
              this.departmentName = successResponse.name;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować nazwy departamentu", errorResponse);
            });
      },

      getContests() {
        PublicContest.getDepartmentContests(this, this.$route.params.departmentId, successResponse => {
              this.contests = successResponse;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować listy konkursów", errorResponse);
            });
      },

      getAgencyContests() {
        AgencyContest.getDepartmentContests(this, this.$route.params.departmentId, successResponse => {
              this.agencyContests = successResponse;
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować listy naborów", errorResponse);
            });
      },

      getNotificationGroups() {
        Notification.getGroups(this, this.$route.params.departmentId, successResponse => {
              this.notificationGroups = this.defaultGroups.concat(successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się załadować listę grup komunikatów", errorResponse);
            });
      },

      createNotificationGroup() {
        Notification.postGroup(this, {
              name: this.editedItem.name,
              departmentId: this.$route.params.departmentId
            },
            successResponse => {
              this.editedItem.id = successResponse;
              this.notificationGroups.push(this.editedItem);
              this.close();
              this.$messagesBus.$emit("success", "Grupa komunikatów została pomyślnie utworzona", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się utworzyć grupy", errorResponse);
            });
      },

      updateNotificationGroup() {
        Notification.putGroup(this, {
              id: this.editedItem.id,
              name: this.editedItem.name,
              departmentId: this.$route.params.departmentId
            },
            successResponse => {
              Object.assign(this.notificationGroups[this.editedIndex], this.editedItem);
              this.close();
              this.$messagesBus.$emit("success", "Grupa komunikatów została pomyślnie zapisana", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się zapisać grupy", errorResponse);
            });
      },

      deleteNotificationGroup(id, index) {
        Notification.deleteGroup(this, id, successResponse => {
              this.notificationGroups.splice(index, 1);
              this.$messagesBus.$emit("success", "Grupa komunikatów została pomyślnie usunięta", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się usunąć grupy", errorResponse);
            });
      },

      sendNotificationToBidders() {
        Api.postMultipart(this, "/notification/bidders-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToVolunteers() {
        Api.postMultipart(this, "/notification/volunteers-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToAgencyEmployees() {
        Api.postMultipart(this, "/notification/agency-employees-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToDepartmentEmployees() {
        Api.postMultipart(this, "/notification/department-employees-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              departmentId: this.$route.params.departmentId
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToGroup() {
        Api.postMultipart(this, "/notification/group-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              groupId: this.notificationRecipientGroup.id
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToContestBidders() {
        Api.postMultipart(this, "/notification/contest-bidders-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              contestId: this.notification.contestId,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToContestVolunteers() {
        Api.postMultipart(this, "/notification/contest-volunteers-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              contestId: this.notification.contestId,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToContestEvaluators() {
        Api.postMultipart(this, "/notification/contest-evaluators-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              contestId: this.notification.contestId,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

      sendNotificationToAgencyContestEvaluators() {
        Api.postMultipart(this, "/notification/agency-contest-evaluators-notification", this.notification.files,
            {
              title: this.notification.title,
              message: this.notification.message,
              contestId: this.notification.contestId,
            }, successResponse => {
              this.$messagesBus.$emit("success", "Komunikat został pomyślnie wysłany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się wysłać komunikatu", errorResponse);
            });
      },

			refresh() {
        this.getNotificationGroups();
        this.getDepartmentName();
        this.getContests();
        this.getAgencyContests();
			},

			removeEmptyTableLoading() {
				let el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},
		},

		mounted() {
			this.removeEmptyTableLoading();
		},

		created() {
			this.refresh();
		},

		watch: {
			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
			},

			messageDialog(val) {
				if (!val) {
					this.notification.contestId = null;
					this.notification.title = '';
					this.notification.message = '';
					this.notification.files = [];
					this.notificationRecipientGroup = {};
					Files.methods.clearFileInput('fileInput');
				}
			},

			"$route.params": function () {
				this.refresh();
			},
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},

			showContestField() {
				return this.notificationRecipientGroup.name === 'Oferenci konkursu' ||
					this.notificationRecipientGroup.name === 'Wolontariusze konkursu' ||
					this.notificationRecipientGroup.name === 'Opiniujący konkursu';
			},

			showAgencyContestField() {
				return this.notificationRecipientGroup.name === 'Opiniujący naboru';
			},
      
      notificationSendDisabled() {
        return this.notification.title === ''
            || (this.showContestField && this.notification.contestId === null)
            || (this.showAgencyContestField && this.notification.contestId === null);
      }
		},
	};
</script>

<style scoped>
	.theme--dark .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
		background-color: #424242 !important;
	}

	.theme--dark .v-alert.v-alert {
		color: #000;
	}
</style>
